import { KibsiClientSDK } from '@kibsi/ks-client-sdk'
import { UiApi, UiKibsiClient } from './client'

export class UiKibsiClientSdk extends KibsiClientSDK {
    ui(): UiApi {
        return this.cacheClient(UiKibsiClient)
    }
}
